<template>
    <v-text-field
        :value="value"
        class="body-2"
        :name="metadata.name"
        :aria-label="formattedAriaLabel(
            metadata[`description${this.upperLocale}`],
            required
        )"
        :label="formattedLabel(
            metadata[`description${this.upperLocale}`],
            required
        )"
        :outlined="outlined"
        :append-icon="appendIcon"
        :color="$vuetify.theme.primary"
        :background-color="$vuetify.theme.primary"
        :close-on-content-click="false"
        autocomplete="off"
        :placeholder="$i18n.locale === 'fr' ? 'AAAA-MM-JJ' : 'YYYY-MM-DD'"
        :rules="[
            !required || requiredField(),
            v => !v || getFormRule('pastDate', 'base.errors.datePast')(v),
        ]"
        :data-meta-id="metadata.id"
        v-facade="$t('base.dateMask')"
        :id="metadata.name"
        @input="emitValue"
    />
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { timezones } from '@/mixins/timezones';
import { authModule } from '@/utils';

export default {
    name: 'offer-letter-sent-date',
    mixins: [formRules, timezones, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    beforeDestroy() {
        this.emitValue(null);
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
            getLoggedUser: `${authModule}/getLoggedUser`,
        }),

        appendIcon() {
            return this.withIcon ? 'far fa-calendar-minus' : '';
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
